/*
  ! DO NOT USE
  TODO : DEPRECATE HOOK
  * Commission Junction is being sunset and replaced by Impact in the first quarter of 2024.
*/

// ignoring coverage for file, all this code was copy pasted from the View Model,
// and since it being deprecated and mocking lazy query is giving me trouble
/* istanbul ignore file */
import { useEffect } from 'react';

import {
  loog,
} from '@express-labs/raven-tools';

import {
  useLazyQuery,
} from '@apollo/react-hooks';

import {
  getComComQueryParams,
} from '../../helpers';

import {
  getSocialSellerInfo,
} from '../../queries';


import SoComSellerAnalytics from '../../helpers/SoCom/SoComSellerAnalytics/SoComSellerAnalytics';

const UseCommissionJunction = () => {
  const isComCom = !!window?.FLAGS?.SoCom;
  const { pathname, search } = window.location;

  const [onTagSellerInfo] = useLazyQuery(getSocialSellerInfo, {
    onCompleted: ({ getSocialSellerInfo: updatedSeller }) => {
      const sellerId = updatedSeller?.sellerInfo?.sellerId;
      if (sellerId) {
        SoComSellerAnalytics('sellerAddedToBag', sellerId);
      }
    },
    onError: (e) => {
      if (window?.isDebugMode) {
        loog(`Error while tag seller into cart: ${e}`, 'info', e);
      }
    },
  });

  useEffect(() => {
    const { sellerId, cjEvent } = getComComQueryParams(search);
    /**
       * Attribute seller information into cart
       * when the pubname is CIQ-Express and PID in qs
       */
    /* istanbul ignore else */
    if (isComCom && sellerId) {
      onTagSellerInfo({
        variables: { sellerId, cjEvent },
      });
    }
  }, [isComCom, onTagSellerInfo, search, pathname]);
};

export default UseCommissionJunction;
